var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5226 0.00015743 19.9999 4.47727 20 10C19.9999 15.5228 15.5226 20.0008 10 20.001C4.47725 20.001 9.75422e-05 15.5229 0 10C0.000136449 4.47717 4.47727 0 10 0ZM10 2C5.58193 2 2.00014 5.58166 2 10C2.0001 14.4184 5.5819 18.001 10 18.001C14.418 18.0008 17.9999 14.4183 18 10C17.9999 5.58175 14.4179 2.00016 10 2ZM10 3.59961C10.552 3.59974 10.9998 4.04761 11 4.59961V9.38184L14.0469 10.9053C14.5407 11.1522 14.7408 11.7532 14.4941 12.2471C14.2471 12.741 13.6463 12.9413 13.1523 12.6943L9.55273 10.8945C9.21403 10.7252 9.00009 10.3787 9 10V4.59961C9.00024 4.04753 9.44786 3.59961 10 3.59961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.71932cb81b448ab37c7b0a5a904dbcf2.svg";
export { ForwardRef as ReactComponent };